import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { PricingPage } from "src/pages/PricingPage";
import { billingProductsQueryOptions } from "src/queries/billing";

export const Route = createFileRoute("/pricing")({
  component: PricingPage,
  ssr: true,
  staticData: {
    getLayoutSettings() {
      return { useAuthLayout: false };
    },
  },
  loader: async ({ context }) => {
    return loaderHandler(async () => {
      await context.queryClient.query({
        ...billingProductsQueryOptions(),
        staleTime: "static",
      });
      return { data: null };
    });
  },
  head: () => {
    return { meta: [{ title: "Pricing – sztama" }] };
  },
});
